import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';

export default function ProposalApplicant(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let proposalId = decode.proposalId;
    let isReadOnly = decode.readOnly;

    let member = prop.member;
    let [detail, setDetail] = React.useState(null);
    let [readOnly, setReadOnly] = React.useState(false);

    //Applicant
    let refPrefix = React.useRef();
    let refFirstname = React.useRef();
    let refLastname = React.useRef();
    let refPrefix_en = React.useRef();
    let refFirstname_en = React.useRef();
    let refLastname_en = React.useRef();
    let refPosition = React.useRef();
    let refDepartment = React.useRef();
    let refContact = React.useRef();
    let refEducation = React.useRef();
    let refWorkHistory = React.useRef();
    let refExpertise = React.useRef();
    let refEmail = React.useRef();
    let refPhone = React.useRef();

    React.useEffect(() => {
        window.scrollTo(0, 0);

        (async function() {
            try {
                const resDetail = await getDetail();
                if(resDetail) {
                    setDetail(resDetail);

                    if([Utils.PROPOSAL_STATUS_APPROVE].includes(resDetail.status)) {
                        setReadOnly(true);
                    }

                    if(isReadOnly) {
                        setReadOnly(isReadOnly);
                    }

                    if(prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                    }

                    refPrefix.current.value = resDetail.applicant.prefix;
                    refFirstname.current.value = resDetail.applicant.firstname;
                    refLastname.current.value = resDetail.applicant.lastname;
                    refPrefix_en.current.value = resDetail.applicant.prefix_en;
                    refFirstname_en.current.value = resDetail.applicant.firstname_en;
                    refLastname_en.current.value = resDetail.applicant.lastname_en;
                    refPosition.current.value = resDetail.applicant.position;
                    refDepartment.current.value = resDetail.applicant.department;
                    refContact.current.value = resDetail.applicant.contact;
                    refEducation.current.value = resDetail.applicant.education;
                    refWorkHistory.current.value = resDetail.applicant.workHistory;
                    refExpertise.current.value = resDetail.applicant.expertise;
                    refEmail.current.value = resDetail.applicant.email;
                    refPhone.current.value = resDetail.applicant.phone;
                }

                document.title = 'ทุนวิจัย Scholarship | NCSA - ' + resDetail.title;
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/proposal/viewProposal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCancel = () => {
        //if(readOnly) {
        //    navigate((prop.lang === 'en' ? '/en':'') + '/proposalApprove');
        //}
        //else {
            navigate((prop.lang === 'en' ? '/en':'') + '/proposal');
        //}
    };

    const onSubmit = async () => {
        let prefix = refPrefix.current.value;
        let firstname = refFirstname.current.value;
        let lastname = refLastname.current.value;
        let prefix_en = refPrefix_en.current.value;
        let firstname_en = refFirstname_en.current.value;
        let lastname_en = refLastname_en.current.value;
        let position = refPosition.current.value;
        let department = refDepartment.current.value;
        let contact = refContact.current.value;
        let education = refEducation.current.value;
        let workHistory = refWorkHistory.current.value;
        let expertise = refExpertise.current.value;
        let email = refEmail.current.value;
        let phone = refPhone.current.value;

        if(prefix === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Prefix (Thai)':'กรุณาระบุ คำนำหน้านาม (ภาษาไทย)');
            refPrefix.current.focus();
        }
        else if(firstname === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Firstname (Thai)':'กรุณาระบุ ชื่อจริง (ภาษาไทย)');
            refFirstname.current.focus();
        }
        else if(lastname === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Lastname (Thai)':'กรุณาระบุ นามสกุล (ภาษาไทย)');
            refLastname.current.focus();
        }
        else if(prefix_en === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Prefix (English)':'กรุณาระบุ คำนำหน้านาม (English)');
            refPrefix_en.current.focus();
        }
        else if(firstname_en === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Firstname (English)':'กรุณาระบุ ชื่อจริง (English)');
            refFirstname_en.current.focus();
        }
        else if(lastname_en === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Lastname (English)':'กรุณาระบุ นามสกุล (English)');
            refLastname_en.current.focus();
        }
        else if(position === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Academic Position':'กรุณาระบุ ตำแหน่งทางวิชาการ');
            refPosition.current.focus();
        }
        else if(department === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Department':'กรุณาระบุ หน่วยงานที่สังกัด');
            refDepartment.current.focus();
        }
        else if(contact === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Contact':'กรุณาระบุ ข้อมูลติดต่อ/ที่อยู่');
            refContact.current.focus();
        }
        else if(email === '' || !Utils.validateEmail.test(email)) {
            toast.error(prop.lang === 'en' ? 'Please specify a valid email':'กรุณาระบุ รูปแบบอีเมลให้ถูกต้อง');
            refEmail.current.focus();
        }
        else if(!phone || isNaN(phone) || phone.length !== 10) {
            toast.error(prop.lang === 'en' ? 'Please specify 10-digit Phone number.':'กรุณาระบุ ระบุเบอร์โทรศัพท์ ตัวเลข 10 หลัก');
            refPhone.current.focus();
        }
        else if(education === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Education':'กรุณาระบุ ประวัติการศึกษา');
            refEducation.current.focus();
        }
        else if(workHistory === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Work History':'กรุณาระบุ ประวัติการทำงาน');
            refWorkHistory.current.focus();
        }
        else if(expertise === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Expertise':'กรุณาระบุ ความเชี่ยวชาญ');
            refExpertise.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            let param = {
                                proposalId: proposalId,
                                prefix: prefix,
                                firstname: firstname,
                                lastname: lastname,
                                prefix_en: prefix_en,
                                firstname_en: firstname_en,
                                lastname_en: lastname_en,
                                position: position,
                                department: department,
                                contact: contact,
                                education: education,
                                workHistory: workHistory,
                                expertise: expertise,
                                email: email,
                                phone: phone,
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await updateApplicant(param);

                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'The applicant\'s information has been recorded successfully.':'บันทึกส่วนข้อมูลผู้ขอรับทุน เรียบร้อย');
                                setTimeout(function () {
                                    navigate((prop.lang === 'en' ? '/en/':'') + '/proposal');
                                }, 1500);
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function updateApplicant(param) {
        const response = await fetch(Config.apiUrl +'/applicant/updateApplicant', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="proposal" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 text-center">{prop.lang === 'en' ? 'Full Proposal':'ยื่นแบบฟอร์มข้อเสนอโครงการฉบับสมบูรณ์ (Full Proposal)'}</h2>
                                <div className="text-center">{prop.lang === 'en' ? 'Strategic Research Project (Strategic Fund; SF): Research Project Type':'โครงการวิจัยเชิงกลยุทธ์ (Strategic Fund; SF) : ประเภทโครงการวิจัย'}</div>
                                <h3 className="mt-2 text-center">{prop.lang === 'en' ? 'Research Fund Name ':'ชื่อทุนวิจัย '} : {prop.lang === 'en' ? detail?.scholarship.title_en : detail?.scholarship.title}</h3>

                                <h3 className="title-bar mt-4 mb-2">{prop.lang === 'en' ? 'Scholarship Applicants':'ข้อมูลผู้ขอรับทุน'}</h3>
                                <div className="row g-4 mt-2">
                                    <div className="col-xl-4 col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Prefix (Thai)':'คำนำหน้า (ภาษาไทย)'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refPrefix} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'First Name (Thai)':'ชื่อจริง (ภาษาไทย)'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refFirstname} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Last Name (Thai)':'นามสกุล (ภาษาไทย)'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refLastname} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Prefix (English)':'คำนำหน้า (English)'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refPrefix_en} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'First Name (English)':'ชื่อจริง (English)'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refFirstname_en} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Last Name (English)':'นามสกุล (English)'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refLastname_en} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Academic Position':'ตำแหน่งทางวิชาการ'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refPosition} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Department':'หน่วยงานที่สังกัด'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refDepartment} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Contact':'ข้อมูลติดต่อ/ที่อยู่'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refContact} maxLength={250} disabled={readOnly}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Phone':'เบอร์โทร'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refPhone} maxLength={10} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Email':'อีเมล'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refEmail} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Education':'ประวัติการศึกษา'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refEducation} maxLength={1000} disabled={readOnly}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Work History':'ประวัติการทำงาน'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refWorkHistory} maxLength={1000} disabled={readOnly}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Expertise':'ความเชี่ยวชาญ'} <span className="star">*</span></h6>
                                            <textarea className="form-control" ref={refExpertise} maxLength={1000} disabled={readOnly}></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div className="py-3"><hr /></div>
                                <div className="buttons gap-15 py-0 mb-4">
                                    <button className="btn btn-gray w-130" type="button" onClick={onCancel}>{prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}</button>
                                    {
                                        !readOnly ? <button className="btn btn-secondary w-130" type="button" onClick={onSubmit}>{prop.lang === 'en' ? 'Save':'บันทึกข้อมูล'}</button> : ''
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 